// src/config/feeConfig.js - Fixed for better compatibility

// Define native token address directly to avoid circular dependencies
const NATIVE_TOKEN_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";

/**
 * Configuration for BitDog wallet fees
 */
export const feeConfig = {
    // Fee percentage in basis points (bps) - 50 bps = 0.5%
    // This should be relatively small to be competitive
    swapFeePercentage: 50, // 0.5%
    
    // Fee receiver address - where fees will be sent
    // IMPORTANT: Replace with your actual fee collection address
    feeReceiver: "0xD3F69F3f97aB747E3D6Cbc9A7636A064Bad147Aa",
    
    // Whether fees are charged in the input or output token - default value
    // 'currency_in' - take fee from the token user is swapping from
    // 'currency_out' - take fee from the token user is receiving
    chargeFeeBy: "currency_out",
    
    // Whether the fee is enabled
    enabled: true
};

/**
 * Determine how fees should be charged based on input and output tokens
 * @param {object} inputToken - Input token object
 * @param {object} outputToken - Output token object
 * @param {object} currentChain - Current blockchain network
 * @returns {string} - 'currency_in' or 'currency_out'
 */
export const determineFeeChargeMethod = (inputToken, outputToken, currentChain) => {
    // Default to currency_out
    let chargeMethod = 'currency_out';
    
    try {
        // Safely check addresses - handle null/undefined cases
        const inputAddress = inputToken?.address ? inputToken.address.toLowerCase() : '';
        const outputAddress = outputToken?.address ? outputToken.address.toLowerCase() : '';
        
        // If we don't have valid addresses, return the default
        if (!inputAddress || !outputAddress) {
            return chargeMethod;
        }
        
        // Get native token address
        const nativeTokenAddress = NATIVE_TOKEN_ADDRESS.toLowerCase();
        
        // Get wrapped native token address if available
        const wrappedNativeAddress = currentChain?.wrappedNativeToken ? 
            currentChain.wrappedNativeToken.toLowerCase() : '';
        
        // Check if input token is native or wrapped native
        const isInputNative = inputAddress === nativeTokenAddress;
        const isInputWrappedNative = wrappedNativeAddress && inputAddress === wrappedNativeAddress;
        
        // Check if output token is native or wrapped native  
        const isOutputNative = outputAddress === nativeTokenAddress;
        const isOutputWrappedNative = wrappedNativeAddress && outputAddress === wrappedNativeAddress;
        
        console.log("Fee configuration analysis:", {
            inputToken: inputToken.symbol,
            inputAddress,
            outputToken: outputToken.symbol,
            outputAddress,
            nativeTokenAddress,
            wrappedNativeAddress,
            isInputNative,
            isInputWrappedNative,
            isOutputNative,
            isOutputWrappedNative
        });
        
        // Apply rules:
        // 1. If input is native/wrapped, charge in input token
        if (isInputNative || isInputWrappedNative) {
            chargeMethod = 'currency_in';
        }
        // 2. If output is native/wrapped, charge in output token
        else if (isOutputNative || isOutputWrappedNative) {
            chargeMethod = 'currency_out';
        }
        // 3. Otherwise, default to output token
    } catch (error) {
        console.error("Error determining fee charge method:", error);
        // Fall back to the default in case of any error
    }
    
    return chargeMethod;
};